import { Result } from 'react-hawksearch';
import { PreviewDataResponse } from 'models/PreviewDataResponse';
import { AppSettings } from 'types';
import { VisitorTarget } from 'models/VisitorTarget';

export class PreviewStore {
	public isLoading: boolean;

	public visitorId: string;

	public currentResult?: Result;

	public siteDirectory: string;

	public clientGuid?: string;

	public websiteUrl?: string;

	public fieldsData?: Map<string, string>;

	public fieldsMapping?: Map<string, string>;

	public visitorsTarget?: VisitorTarget[];

	public isUsingDefaultSimilarityAlgorithm: boolean;

	public preselectedVisitors?: number[];

	public settings: AppSettings;

	public clientIndexes: string[];

	public itemsToCompare: Result[];
	public currentSearchIndex: string;

	public cartItems: Result[];
	public showCartPopup: boolean;
	public constructor(initial?: Partial<PreviewStore>) {
		Object.assign(this, initial);
	}

	public get isInitialLoad() {
		return this.isLoading && !this.currentResult;
	}
}
